<template>
    <menu class="base-filters">
        <template v-if="pending">
            <li
                v-for="i in [1,2,3,4]"
                :key="i"
                width="80%"
            >
                <Skeletor />
            </li>
        </template>

        <template v-else>
            <li v-if="!!$slots['all-filters'] || !!$slots['all-filters-wrapper']">
                <slot
                    name="all-filters-wrapper"
                    :active-filters="activeFilters"
                >
                    <BaseDotLink
                        :active="activeFilters?.length === 0 || activeFilters?.includes(null)"
                        @click="$emit('update:clearFilters')"
                    >
                        <slot name="all-filters" />
                    </BaseDotLink>
                </slot>
            </li>
            <li
                v-for="(item, index) in items"
                :key="`filter-${index}`"
                :class="{
                    'base-filters__item--hide-small': hideSmall
                }"
            >
                <slot :name="`filter-${index}`">
                    <BaseDotLink
                        :active="activeFilters?.includes(item.id)"
                        @click="$emit('update:activeFilter', item.id)"
                    >
                        {{ item.title }}
                    </BaseDotLink>
                </slot>
            </li>
        </template>
    </menu>
</template>

<script setup>
defineProps({
    pending: {
        type: Boolean,
        default: false
    },
    activeFilters: {
        type: Array,
        default: () => []
    },
    items: {
        type: Array,
        default: () => []
    },
    hideSmall: {
        type: Boolean,
        default: false
    }
});

defineEmits(['update:activeFilter', 'update:clearFilters']);
</script>

<style lang="less">
.base-filters {
    .typography-label();
    .list-clean();

    display: flex;
    flex-direction: row;
    padding-right: var(--spacing-sm);

    overflow: auto;
    white-space: nowrap;

    // Remove scrollbar
    scrollbar-width: none;

    &::-webkit-scrollbar {
        display: none;
    }

    gap: var(--spacing-sm);
    font-size: .875rem;

    @media @q-md-min {
        gap: var(--spacing-md);
        flex-direction: column;

        font-size: 1rem;
    }
}

.base-filters__item--hide-small {
    @media @q-md-max {
        display: none;
    }
}
</style>
